// @flow

import Q from 'q';

import $ from 'rgs-jquery';
import ko from 'rgs-knockout';

import globalConfig from 'config';

import ViewModel from './view-model.js';
import template from './templates/template.html';

const VIEW_SELECTOR = '#rgs-lk-button';

async function main () {
	await new Q.Promise(resolve => $(resolve));

	const view = $(VIEW_SELECTOR)[0];

	if (!view) {
		console.warn(
			`'${VIEW_SELECTOR}' was not found in the DOM, my rgs button will not appear`
		);
		return;
	}

	const pageUrls = await globalConfig.cms.pageUrls.get();

	const viewModel = new ViewModel({
		myrgsBaseUrl: pageUrls.mr.home,
	});

	ko.applyBindingsToNode(view, {
		template: {
			html: template(),
			data: viewModel,
		},

		// HACK: turn into dropdown when authorized
		// TODO: encode this behaviour in the template
		css: {
			dropdown: viewModel.IsLoggedIn,
		},
	});
}

Q(main()).done();
